import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { KendoModule } from "./kendo.modules";
import { FileNameTransformPipe } from "../pipes/filename-transform.pipe";
import { RouterModule } from "@angular/router";
import { FileSizeTransformPipe } from "../pipes/filesize-transform.pipe";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { SafeStringPipe } from "../pipes/safe-string.pipe";

@NgModule({
    declarations: [FileNameTransformPipe, FileSizeTransformPipe, SafeStringPipe],
    exports: [
        CommonModule,
        FontAwesomeModule,
        KendoModule,
        FileNameTransformPipe,
        FileSizeTransformPipe,
        SafeStringPipe,
        RouterModule
    ],
    providers: [DatePipe]
})
export class CommonPackageModule { }